/* 
WARNING: these colors were sampled, and may not be accurate.
TODO: verify colors
Source: https://wiki.cvent.com/pages/viewpage.action?spaceKey=UX&title=White+Label+Theming
*/

/* standard cvent themes */

export const gather = {
  primary: '#182261',
  secondary: '#006AE1',
  additionalColor1: '#8FD3D8',
  additionalColor2: '#F4F4F4',
  additionalColor3: '#FFFFFF'
};

export const clean = {
  primary: '#273F69',
  secondary: '#041532',
  additionalColor1: '#F7F7F7',
  additionalColor2: '#FFFFFF',
  additionalColor3: '#DDE2E6'
};

export const twist = {
  primary: '#572370',
  secondary: '#9237A5',
  additionalColor1: '#F0629C',
  additionalColor2: '#FFFFFF',
  additionalColor3: '#FFF6F0'
};

export const serene = {
  primary: '#3A3C53',
  secondary: '#345A5E',
  additionalColor1: '#FC5F27',
  additionalColor2: '#F0F5F6',
  additionalColor3: '#FFFFFF'
};

export const vigor = {
  primary: '#D45F34',
  secondary: '#600100',
  additionalColor1: '#FFDF3C',
  additionalColor2: '#FCEFED',
  additionalColor3: '#FFFFFF'
};

export const cordial = {
  primary: '#0B4F6C',
  secondary: '#D50101',
  additionalColor1: '#6ED7E6',
  additionalColor2: '#FEFAFF',
  additionalColor3: '#D8E9EF'
};

export const capital = {
  primary: '#003637',
  secondary: '#007A7C',
  additionalColor1: '#0DAA4B',
  additionalColor2: '#FFFFFF',
  additionalColor3: '#E5E5E5'
};
